import type React from 'react'
import type { IconProps } from './types'

const ChevUpIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M20 14.5798L18.58 15.9998L12 9.41981L5.42 15.9998L4 14.5798L12 6.57981L20 14.5798Z' />
	</svg>
)

export default ChevUpIcon
